// Stock units (Back office sweep, Oct 2026). A short list to pick from, not a box to type
// into: kg, g, L, ml, each, or a case of so many. Older items keep whatever they were set to
// ("litre", "bottle") until someone picks again.

export const UNITS = ['kg', 'g', 'L', 'ml', 'each', 'case'];

// "case of 12" → { base: 'case', of: 12 }; anything else → { base: unit }
export function parseUnit(unit) {
  const m = /^case of (\d+)$/i.exec(String(unit || '').trim());
  if (m) return { base: 'case', of: Number(m[1]) };
  return { base: String(unit || '').trim() };
}

export const caseOf = (n) => `case of ${n}`;

// "8 kg", "18" (each), "0.5 kg", "2 cases of 12"
export const qty = (n, unit) => {
  const v = Number(n || 0);
  const s = Number.isInteger(v) ? String(v) : String(Math.round(v * 1000) / 1000);
  if (!unit || unit === 'each') return s;
  const u = parseUnit(unit);
  if (u.base === 'case') return `${s} ${v === 1 ? 'case' : 'cases'}${u.of ? ` of ${u.of}` : ''}`;
  return `${s} ${unit}`;
};

// The smaller unit a quantity can be typed in: grams for a kg item, ml for a litre one.
const SMALL = { kg: 'g', L: 'ml', l: 'ml', litre: 'ml', liters: 'ml', litres: 'ml' };
export const smallUnit = (unit) => SMALL[unit] || null;
export const fromSmall = (n) => Number(n) / 1000;

// A unit as a price is quoted per it (Chris's review L2): "£0.35 / unit", not "/units".
// Items keep the unit they were saved with ("bottles", "heads"); only the price reads singular.
const SINGULAR = { liters: 'litre', litres: 'litre', liter: 'litre', boxes: 'box', bunches: 'bunch', each: 'each' };
export const perUnit = (unit) => {
  const u = String(unit || '').trim();
  if (SINGULAR[u.toLowerCase()]) return SINGULAR[u.toLowerCase()];
  if (/^case of/i.test(u)) return 'case';
  if (/[^s]s$/i.test(u) && u.length > 3) return u.slice(0, -1);
  return u;
};
